import {
  Delete,
  RemoveCircleOutline,
  AddCircleOutline,
} from '@mui/icons-material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { unitCaseEnum } from '../../utils/settings';
import { Typography, Button, IconButton, Box, TextField } from '@mui/material';
import NO_IMAGE from '../Utils/Assets/noImage.jpg';
import { toast } from 'react-toastify';

function FmcgProdCard({ prod, index, itemInCart = {} }) {
  const dispatch = useDispatch();
  const [enteredValue, setEnteredValue] = useState('');

  const { product_info, allocable_quantity, price_info } = prod;

  const { unitCaseWise } = useSelector((state) => ({
    unitCaseWise: state.fmcgReducer.unitCaseWise,
  }));

  const updateProdQty = ({ type, data, inputValue = null }) => {
    setEnteredValue('');

    const unitQty = data.allocable_quantity.quantity_in_bags;
    const caseQty = data.allocable_quantity.quantity_in_metric_ton;

    if (unitCaseWise === unitCaseEnum['CASE'] && caseQty < 1)
      return toast.error('Not enough Cases to add');

    if (
      inputValue &&
      unitCaseWise === unitCaseEnum['UNIT'] &&
      unitQty < Number(inputValue)
    )
      return toast.error('Not enough Units to add');

    dispatch({
      type: 'UPDATE_PROD_QTY',
      data: { type, data, inputValue },
    });
  };

  const removeProduct = () => {
    updateProdQty({ type: 'DELETE', data: prod });
  };

  return (
    <Box
      key={index}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        p: 2,
        boxShadow: 1,
        borderRadius: 2,
        position: 'relative',
        backgroundColor: '#fff',
        mb: 2,
      }}
    >
      <IconButton
        onClick={removeProduct}
        sx={{ position: 'absolute', top: 8, right: 8 }}
        color='error'
      >
        <Delete />
      </IconButton>

      <Box
        component='img'
        src={product_info?.product_logo?.split(',')[0] || NO_IMAGE}
        alt='product'
        sx={{ width: 100, height: 100, objectFit: 'contain' }}
      />

      <Box sx={{ flex: 1 }}>
        <Typography variant='subtitle1' fontWeight='bold'>
          {product_info?.product_name}
        </Typography>
        <Typography variant='body2'>{prod.meta_data?.Type}</Typography>

        {price_info?.mrp > 0 && price_info?.rlp > 0 && (
          <Box sx={{ mt: 1 }}>
            <Typography variant='body1' color='primary'>
              ₹{' '}
              {unitCaseWise === unitCaseEnum['UNIT']
                ? price_info.rlp.toFixed(2)
                : (price_info.rlp * allocable_quantity?.multiplier).toFixed(2)}
            </Typography>
            <Typography
              variant='body2'
              sx={{ textDecoration: 'line-through', color: 'gray' }}
            >
              ₹{' '}
              {unitCaseWise === unitCaseEnum['UNIT']
                ? price_info.mrp.toFixed(2)
                : (price_info.mrp * allocable_quantity?.multiplier).toFixed(2)}
            </Typography>
          </Box>
        )}

        <Typography variant='body2' sx={{ mt: 1 }}>
          {unitCaseWise === unitCaseEnum['UNIT']
            ? `${allocable_quantity?.quantity_in_bags} ${allocable_quantity?.base_unit}`
            : `${allocable_quantity?.quantity_in_metric_ton} ${allocable_quantity?.unit} (${allocable_quantity?.multiplier} ${allocable_quantity?.base_unit} / ${allocable_quantity?.unit})`}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mt: 1,
            flexWrap: 'wrap',
          }}
        >
          <IconButton
            onClick={() => updateProdQty({ type: 'REMOVE', data: prod })}
          >
            <RemoveCircleOutline />
          </IconButton>

          <TextField
            variant='outlined'
            size='small'
            value={
              enteredValue
                ? enteredValue
                : itemInCart?.sellToBuyerQty?.qty || 0
            }
            onChange={(e) => {
              const userInput = e.target.value;
              const regex = /^[0-9]*$/;
              if (regex.test(userInput)) {
                setEnteredValue(userInput);
              }
            }}
            onBlur={() =>
              updateProdQty({
                type: 'ADD',
                data: prod,
                inputValue: Number(enteredValue),
              })
            }
            sx={{
              width: 60,
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  border: 'none',
                  borderBottom: '1px solid #000',
                  borderRadius: 0,
                },
              },
            }}
          />

          <IconButton
            onClick={() => updateProdQty({ type: 'ADD', data: prod })}
          >
            <AddCircleOutline />
          </IconButton>

          <Typography variant='body2'>
            {unitCaseWise === unitCaseEnum['UNIT']
              ? `${allocable_quantity?.base_unit}`
              : `${allocable_quantity?.unit}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default FmcgProdCard;
